import { render, staticRenderFns } from "./okato-selector.vue?vue&type=template&id=05fab2b5&"
import script from "./okato-selector.vue?vue&type=script&lang=ts&"
export * from "./okato-selector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports